import styled from "styled-components";

export type TagTone = "neutral" | "gold" | "teal" | "cherry" | "night" | "muted";

const TONES: Record<TagTone, [bg: string, fg: string, border: string]> = {
  neutral: ["var(--card-sunken)", "var(--ink-soft)", "var(--line)"],
  gold: ["var(--gold-tint)", "var(--warn)", "var(--gold)"],
  teal: ["var(--teal-tint)", "var(--teal-shade)", "var(--teal)"],
  cherry: ["var(--cherry-tint)", "var(--cherry-shade)", "var(--cherry)"],
  night: ["var(--night)", "var(--night-ink)", "var(--night-lip)"],
  muted: ["transparent", "var(--ink-faint)", "var(--line-strong)"],
};

/** Small pill label. Optional leading <Icon size={14} />. */
const Tag = styled.span<{ $tone?: TagTone; $size?: "sm" | "md" }>`
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  width: fit-content;
  white-space: nowrap;
  font-family: var(--font-body);
  font-weight: 800;
  font-size: ${({ $size }) => ($size === "md" ? "var(--text-sm)" : "var(--text-xs)")};
  line-height: 1.4;
  padding: ${({ $size }) => ($size === "md" ? "3px var(--space-3)" : "2px var(--space-2)")};
  border-radius: var(--radius-full);
  border: var(--border-w) solid ${({ $tone = "neutral" }) => TONES[$tone][2]};
  background: ${({ $tone = "neutral" }) => TONES[$tone][0]};
  color: ${({ $tone = "neutral" }) => TONES[$tone][1]};
  animation: pop-in var(--dur-slow) var(--ease-bounce) both;
`;

export default Tag;
